import styled from 'styled-components';

export const AccrualIdConfigurationForm = styled.form``;

export const AccrualIdConfigurationHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const AccrualIdConfigurationBody = styled.div`
  padding: 20px;
  border-radius: 20px;
  background: white;
`;

export const AccrualIdConfigurationFooter = styled.div`
  display: flex;
  justify-content: end;
  margin-top: 8px;
`;
